import React from "react";
import {
  ColumnSortConfig,
  SortConfig,
  SortableFields,
} from "../../../pages/UnifiedReminderPage/types/sortTypes";
import { SortIcon } from "../SortIcon/SortIcon";
import styles from "./SortHeader.module.scss";

interface SortHeaderProps {
  config: ColumnSortConfig;
  currentSort: SortConfig[];
  onSort: (field: SortableFields) => void;
}

export const SortHeader: React.FC<SortHeaderProps> = ({
  config,
  currentSort,
  onSort,
}) => {
  const sortState = currentSort.find((s) => s.field === config.field);

  const handleClick = () => {
    if (config.sortable) {
      onSort(config.field);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (config.sortable && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onSort(config.field);
    }
  };

  return (
    <div
      className={`${styles.sortHeader} ${
        config.sortable ? styles.sortable : ""
      }`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role={config.sortable ? "button" : undefined}
      tabIndex={config.sortable ? 0 : undefined}
      aria-label={
        config.sortable
          ? `Sort by ${config.label}${
              sortState ? `, currently ${sortState.direction}ending` : ""
            }`
          : config.label
      }
    >
      <span>{config.label}</span>
      {config.sortable && <SortIcon direction={sortState?.direction} />}
    </div>
  );
};
